import { render, staticRenderFns } from "./CertificateProcessTypesSave.vue?vue&type=template&id=2351e684&scoped=true&"
import script from "./CertificateProcessTypesSave.vue?vue&type=script&lang=js&"
export * from "./CertificateProcessTypesSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351e684",
  null
  
)

export default component.exports